export const quizPracticeLink = "https://www.giac.org/frequently-asked-questions/#practice";
export const myCoursesUrl = "https://ondemand.sans.org/";
export const accountDashboardUrl = "https://www.sans.org/account";
export const logoutUrl = "https://www.sans.org/account/logout";
export const sansHomeUrl = "https://www.sans.org/";
export const impersonationLoadingMessageKey = "impersonationLoadingMessage";
export const impersonationAdminReturnUrlKey = "impersonationAdminReturnUrl";
export const impersonationAdminReturnUrlParam = "adminReturnUrl";
export const impersonationReturnToAdminKey = "impersonationReturnToAdmin";
export const privacyPolicyUrl = "https://www.sans.org/privacy/";
import { env } from "./env";

export const telemetryApiUrl: string = env.VITE_TELEMETRY_ENDPOINT as string;
export const telemetryChannelName = "telemetry";
export const playerModality = "web2";
export const speedModifier = 0.1;
export const timeoutSeconds = 90;
export const saveProgressInterval = 60;
export const dropboxOauthUrl = "https://www.dropbox.com/oauth2/authorize";
export const testNetworkSpeedSettings = {
  testFilePath: "/assets/1mb-test-data.txt",
  networkSpeedCheckMinMinutes: 5,
};

// Video Quality Selection Logic
export const VIDEO_QUALITY_THRESHOLDS = {
  VBR: 0.0, // Variable bitrate - no threshold
  FHD: 5.0, // 1080p - requires 5+ Mbps
  HD: 3.0, // 720p - requires 3+ Mbps
  SD: 0.0, // 480p - fallback for slower connections
};

// Error Messages
export const FORBIDDEN_VIDEO_ERROR_MESSAGE = "video playback is blocked";
export const DEFAULT_SLIDE_UUID = "00000000-0000-0000-0000-000000000000";
export const EXPECTED_MEDIA_PLAYBACK_REJECTION_MESSAGES = {
  playFailed: "play() failed",
  missingUserInteraction: "user didn't interact with the document first",
  interruptedByPause: "the play() request was interrupted by a call to pause()",
  mediaFetchAborted: "the fetching process for the media resource was aborted by the user agent at the user's request",
} as const;
